// extracted by mini-css-extract-plugin
module.exports = {"opportunityDescription":"_c9142a1","starSubIcon":"_ee1eba0","inPlayIcon":"_ec033a8"};